import cn from 'classnames'
import { FunctionComponent, useCallback, useRef } from 'react'

import { NavigationLink } from '@/modules/MainLayout/components/NavigationLink'
import { navigationMenuStore } from '@/store/NavigationMenu'

import { NavigationLinkWithSubMenu } from '../NavigationLinkWithSubMenu'

import { observer } from 'mobx-react-lite'
import styles from './Navigation.module.scss'

type NavigationProps = {
  linkClick?: () => void
  toggleNavigationMenu?: () => void
  className?: string
  telegram: string
  whatsapp: string
  max: string
}
export const Navigation: FunctionComponent<NavigationProps> = observer(
  ({ className, toggleNavigationMenu, linkClick, telegram, whatsapp, max }) => {
    // При переключении подменю на другое подменю, не нужно менять шапку
    // закрытие одного подменю и открытие другого происходит не последовательно
    // поэтому тут идет подсчет сколько раз меню открылось, а сколько закрылось.
    const visibleMenuCount = useRef(0)

    const onOpenMenu = useCallback(() => {
      if (visibleMenuCount.current === 0 && toggleNavigationMenu != null) {
        toggleNavigationMenu()
      }
      visibleMenuCount.current++
    }, [toggleNavigationMenu])

    const onCloseMenu = useCallback(() => {
      if (visibleMenuCount.current === 1 && toggleNavigationMenu != null) {
        toggleNavigationMenu()
      }
      visibleMenuCount.current--
    }, [toggleNavigationMenu])

    return (
      <nav className={cn(className, styles.container)}>
        {navigationMenuStore.menu.map((menuItem) => {
          if (menuItem.children.length !== 0) {
            return (
              <NavigationLinkWithSubMenu
                key={menuItem.title}
                title={menuItem.title}
                subMenu={menuItem.children}
                onOpenMenu={onOpenMenu}
                onHideMenu={onCloseMenu}
                onLinkClick={linkClick}
                telegram={telegram}
                whatsapp={whatsapp}
                max={max}
              />
            )
          } else {
            return (
              <NavigationLink
                onClick={linkClick}
                key={menuItem.title}
                link={menuItem.href ?? ''}
                title={menuItem.title}
              />
            )
          }
        })}
      </nav>
    )
  }
)
